<template>
  <div class="register-view" :style="{ '--height': height, }">
    <div class="index-view-top">
      <div class="logo"><img src="../assets/768.png" alt=""></div>
      <div class="toRegister" @click="toLogin">{{ $t("register.nowLogin") }}</div>
    </div>
    <div class="index-view-top">
      <!-- <van-icon name="arrow-left" size="28" color="#ffffff" @click="toLogin" /> -->
    </div>
    <div class="welcome">
      <div>{{ $t("phone.qd") }}</div>
    </div>
    <div class="login-tips">{{ $t("register.login") }}</div>
    <van-cell-group inset style="margin: 0 1.875rem 1rem">
      <img class="left" src="../assets/1000.png" alt="" />
      <van-field v-model="account" :placeholder="tips1" />
    </van-cell-group>
    <van-cell-group inset style="margin: 0 1.875rem 1rem">
      <img class="left" src="../assets/1001.png" alt="" />
      <van-field v-model="password" :type="passwordType" :placeholder="tips2">
        <template #button><img v-if="passwordType == 'password'" class="password-show" src="../../static/hide.png"
            @click="changePasswordType" style="height: 1rem" alt="" /><img v-else class="password-show"
            src="../../static/show.png" @click="changePasswordType" alt="" /></template>
      </van-field>
    </van-cell-group>
    <van-cell-group inset style="margin: 0 1.875rem 1rem">
      <img class="left" src="../assets/1001.png" alt="" />
      <van-field v-model="confirmPassword" :type="passwordType1" :placeholder="tips3">
        <template #button><img v-if="passwordType1 == 'password'" class="password-show" src="../../static/hide.png"
            @click="changePasswordType1" style="height: 1rem" alt="" /><img v-else class="password-show"
            src="../../static/show.png" @click="changePasswordType1" alt="" /></template>
      </van-field>
    </van-cell-group>
    <van-cell-group inset style="margin: 0 1.875rem 1rem">
      <img class="left" src="../assets/1005.png" alt="" />
      <van-field v-model="inviteCode" :disabled="disabled" :placeholder="tips4" />
    </van-cell-group>
    <div class="verification">
      <van-cell-group inset style="margin: 0 1.875rem 1rem">
        <van-field v-model="verificationCode" :placeholder="tips5" />
      </van-cell-group>
      <div class="verification-image" @click="updateIdentifyCode">
        <identify :identifyCode="identifyCode"></identify>
      </div>
    </div>
    <div class="nowLogin">
      <div @click="toRegister">
        <p>{{ $t("register.toRegister") }}</p>
      </div>
    </div>
    <!-- <div class="no-account">
      <p>{{ $t("register.login") }}？</p>
      <p @click="toLogin">{{ $t("register.toLogin") }}</p>
    </div> -->
  </div>
</template>

<script>
import { register, login } from '@/utils/request'
import identify from '../components/code' //**引入验证码组件**
export default {
  components: {
    identify
  },
  data() {
    return {
      account: '', //账号
      password: '', //密码
      confirmPassword: '', //确认密码
      inviteCode: '', //邀请码
      verificationCode: '', //验证码
      identifyCode: '',
      passwordType: 'password',
      passwordType1: 'password',
      height: '', //屏幕高度
      tips1: '',
      tips2: '',
      tips3: '',
      tips4: '',
      tips5: '', //输入框提示
      disabled: false
    }
  },
  //获取屏幕高度
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.inviteCode = this.$route.query.code
      this.disabled = true
    }
    this.tips1 = this.$t('register.account')
    this.tips2 = this.$t('register.password')
    this.tips3 = this.$t('register.confirm_password')
    this.tips4 = this.$t('register.inviteCode')
    this.tips5 = this.$t('register.verificationCode')
    this.updateIdentifyCode()
  },
  methods: {
    toLogin() {
      this.$router.push('/index')
    },
    //密码的显示与隐藏
    changePasswordType() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    //密码的显示与隐藏
    changePasswordType1() {
      if (this.passwordType1 == 'password') {
        this.passwordType1 = 'text'
      } else {
        this.passwordType1 = 'password'
      }
    },
    //更新图形验证码
    updateIdentifyCode() {
      this.identifyCode = parseInt(Math.random() * 8999) + 1000 + 1 + ''
    },
    toRegister() {
      let _this = this

      if (_this.identifyCode != _this.verificationCode) {
        this.$toast(this.$t('prompt.verification'))
        return
      }
      // 手机号正则验证
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
      let reg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/
      console.log(_this.account)
      if (!reg.test(_this.account)) {
        this.$toast(this.$t('prompt.account'))
      } else if (!reg2.test(_this.password)) {
        this.$toast(this.$t('prompt.password'))
      } else if (_this.password != _this.confirmPassword) {
        this.$toast(this.$t('prompt.two'))
      } else if (_this.password == _this.account) {
        this.$toast(this.$t('prompt.yizhi'))
      } else {
        register({
          account: _this.account,
          password: _this.password,
          inviteCode: _this.inviteCode
        }).then(res => {
          if (res.code == '200') {
            this.$toast.success(this.$t('prompt.successful'))
            setTimeout(() => {
              login({
                account: _this.account,
                password: _this.password
              }).then(res => {
                if (res.code == '200') {
                  this.$toast.success(this.$t('prompt.loginsuccessful'))
                  localStorage.setItem('token', res.data.token)
                  this.$store.commit('changeUserName', this.account)
                  if (res.data.bindWalletStatus == true) {
                    setTimeout(() => {
                      this.$router.push('/luckyhash')
                    }, 500)
                  } else {
                    setTimeout(() => {
                      this.$router.push('/address')
                    }, 500)
                  }
                } else {
                  this.$toast.success(res.msg)
                }
              })
            }, 1000)
          } else {
            this.$toast.success(res.msg)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.register-view {
  width: 100vw;
  height: var(--height);
  background: #020017;

  .verification {
    display: flex;

    .verification-image {
      width: 5.625rem;
      height: 2.5rem;
      border: 0.0625rem solid #484848;
    }
  }

  .password-show {
    display: block;
    width: 1.1875rem;
    height: 0.875rem;
  }

  .index-view-top {
    height: 3.125rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.9375rem;

    .count {
      >img {
        width: 24px;
        height: 24px;
      }
    }

    .toRegister {
      font-size: 0.9375rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }

  .logo {
    >img {
      display: block;
      width: 61.5px;
      height: 38px;
    }
  }

  .login-tips {
    font-size: 0.9375rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    padding: 0 1.875rem 2.1875rem;
  }

  .welcome {
    padding: 0.9375rem 1.875rem 0.9375rem;
    display: flex;

    >div {
      font-size: 1.25rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .no-account {
    display: flex;
    align-items: center;
    justify-content: center;

    >p {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
    }

    >p:nth-child(1) {
      color: #999999;
    }

    >p:nth-child(2) {
      color: #ffffff;
    }
  }

  .nowLogin {
    padding: 0 1.875rem;
    margin-bottom: 0.9375rem;
    margin-top: 3rem;

    >div {
      width: 100%;
      height: 2.6875rem;
      background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
      border-radius: 1.375rem;
      display: flex;
      align-items: center;
      justify-content: center;

      >p {
        font-size: 0.9375rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #0c0b0b;
      }
    }
  }

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: unset;
  }

  /deep/ .van-field__control {
    color: #ffffff !important;
  }

  .van-cell {
    background: #110E31;
    //border-radius: 1.375rem;
    padding-left: 0.5rem;
  }

  .van-cell-group {
    background: #110E31;
    border-radius: 1.375rem;
    margin: 0 1.875rem 1rem;
    display: flex;
    padding-left: 1rem;
    align-items: center;

    .left {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/register.vue